<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ButtonAll from '../UI/Button/ButtonAll.vue'

export default {
  components: { ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    contractId: { type: Number, required: true },
    contractNumber: { type: String, required: true },
  },
  methods: {
    goToContractSimulation() {
      window.location = `/devis/simulation.php?index=creer&cid=${this.contractId}&cn=${this.contractNumber}&t=1`
    },
  },
}
</script>
<template>
  <div>
    <div class="row d-flex justify-content-center my-3">
      <ButtonAll
        margin="no"
        @click="goToContractSimulation"
        type="validation"
        label="restructuration.button.equipmentsAdd"
      ></ButtonAll>
    </div>
  </div>
</template>
